import { Component, OnInit } from '@angular/core';
import { CredentialsService } from 'src/app/authentication/credentials/credentials.service';
import { Response } from 'src/services/classes/models/response.interface';
import { Logger } from 'src/services/core/logger/logger.service';
import { AccountService } from 'src/services/data/account/account.service';
import { NotificationsService } from 'src/services/classes/notifications/notifications.service';

const log = new Logger('Header');

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isOnline = false;

  constructor(
    private credentialsService: CredentialsService,
    private accountService: AccountService,
    private notifyService: NotificationsService
  ) {}

  ngOnInit(): void {
    this.isOnline = this.credentialsService.isOnline();

    addEventListener('reset-online-status', () => {
      setTimeout(() => {
        this.isOnline = this.credentialsService.isOnline();
      }, 0);
    });
  }

  credentials = () => this.credentialsService.credentials;

  changeOnlineStatus(status: boolean) {
    const onlineStatus$ = this.accountService.updateOnlineStatus(status);
    onlineStatus$.subscribe({
      next: (res: Response) => {
        if (res.status.toLowerCase() === 'success') {
          if (res.data) {
            const credentials: any = {
              ...this.credentialsService.credentials,
              onlineStatus: res.data.status,
            };
            this.credentialsService.setCredentials(credentials);
            this.isOnline = res.data.status;
          }
          res?.message
            ? this.notifyService.publishMessages(res.message, 'success', 1)
            : this.notifyService.publishMessages(
                'Online status updated',
                'success',
                1
              );
          dispatchEvent(
            new CustomEvent('reset-online-sidebar-status', {
              bubbles: false,
              cancelable: false,
            })
          );
        } else {
          res?.message
            ? this.notifyService.publishMessages(res.message, 'danger', 1)
            : this.notifyService.publishMessages(
                'An error occurred',
                'danger',
                1
              );
        }
      },
      error: (error) => log.debug('error: ', error),
    });
  }

  openSidebar() {
    dispatchEvent(
      new CustomEvent('open-menu-drawer', {
        bubbles: false,
        cancelable: false,
      })
    );
  }
}
